import { CardId, NationalityPeriod } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const selectNationalityPeriodArray = Object.values(NationalityPeriod).map((value) => ({
  value,
  display: <Text tId={`NATIONALITY_PERIOD_${value}`} />,
}));

export const selectCardIdArray = Object.values(CardId).map((value) => ({
  value,
  display: <Text tId={`CARD_ID_${value}`} />,
}));
